import * as styles from './Main.module.css'

function Main({ children, className = styles.Main }) {
  return <main className={className}>{children}</main>
}

export default Main
